import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routings
const Home = Loadable(lazy(() => import('views/dashboard/home')));
const Monitor = Loadable(lazy(() => import('views/dashboard/monitor')));
const Collect = Loadable(lazy(() => import('views/dashboard/collect')));
const Settings = Loadable(lazy(() => import('views/dashboard/settings')));
const CreditApps = Loadable(lazy(() => import('views/dashboard/credit-apps')));
const CreditAppDetail = Loadable(lazy(() => import('views/dashboard/credit-apps/CreditAppDetail')));
const Admin = Loadable(lazy(() => import('views/dashboard/admin')));

//404 page Routing
const FourZeroFourPage = Loadable(lazy(() => import('views/pages/other/404-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/dashboard/default',
      element: <Home />
    },
    {
      path: '/dashboard',
      element: <Home />
    },
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/monitoring',
      element: <Monitor />
    },
    {
      path: '/collections',
      element: <Collect />
    },
    {
      path: '/settings',
      element: <Settings />
    },
    {
      path: '/credit-apps',
      element: <CreditApps />
    },
    {
      path: '/credit-apps/:id',
      element: <CreditAppDetail />
    },
    {
      path: '/admin',
      element: <Admin />
    },
    //catch all for 404
    {
      path: '*',
      element: <FourZeroFourPage />
    }
  ]
};

export default MainRoutes;
